export default {
    default: 'demands',
    detail: 'demands/:id',
    changeInfoInit: 'demands/change-infos/init',
    changeInfoFromDate: 'demands/change-infos/fromDate',
    changeInfoEndDate: 'demands/end-date',
    changeInfoBudget: 'demands/change-infos/budget',
    preview: 'demands/:id/preview',
    search: 'demands/search',
    smartSuggestion: 'demands/smart-suggestion',
    proposal: 'demands/:id/proposal',
    histories: 'demands/:id/histories',
    token2Detail: 'demands/populate/token2detail',
    detail2Token: 'demands/populate/detail2Token',
    token2Condition: 'demands/populate-condition/token2Detail',
    condition2Token: 'demands/populate-condition/detail2Token',
    calculatePrice: 'demands/calculate-price',
    getQuickSearchDemands: 'demands/quicksearch?text=:ids&type=ids',
    getHtmlDescriptions: 'demands/html-descs',
    getDemandConfigs: 'demands/configs',
    getDemandPreviewById: 'demands/:id/preview',
    matching: 'demands/matching/:propertyId',
    matchingCount: 'demands/count-matching/:propertyId',
    deleteAll: 'demands/delete-all',
    initDemandWithProperty: 'demands/generate-detail'
}